export default __webpack_public_path__ + "static/media/vrbo.4bdc1d3d.png";